import React from 'react';
import './DownloadIcon.css';

const DownloadIcon = () => <i className={`togo-icon togo-icon-download downloadIconCustom`} />;

export default DownloadIcon;



// WEBPACK FOOTER //
// ./src/Components/Buttons/DownloadIcon.js